import * as yup from "yup"
import dayjs from "dayjs";
import { ReportsRightLayout } from ".";
import { Grid, Skeleton, Typography, Dialog, DialogContent, DialogActions, Button, Theme } from "@mui/material";
import { Form, Formik , FormikProps} from "formik";
import { DayJsDatePicker } from "../onboarding/newDatePicker";
import { MFSubmitButton } from "../../lib/formik";
import { Location } from "history"
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux-store/reducers";
import { useState , useRef } from "react";
import { getCustomerTransactionHistoryReport } from "../../redux-store/actions/reports";
import { reportDownload } from "../Reports/report-utils";
import { CONTENT_TYPE } from "../../utils/constant";
import MFSelectField from "../../lib/formik/SelectField";
import { SuccessIcon, FailureIcon } from "../../assets/SvgIcons";
const downloadOptions = [
  { key: 'PDF', value: 'pdf' },
  { key: 'Excel', value: 'excel' },
]

const shareViaOptions = [
  { key: 'Email', value: 'email' },
  { key: 'Download', value: 'download' }
]
// const TransactionStatement = ({
//   location
// }: {
//   location: Location<{ investorId: string; investorName: string }>
// }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const { enqueueSnackbar } = useSnackbar();
//   const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
//   const history = useHistory();
//   const currentDate = dayjs();
//   const [loading, setLoading] = useState<boolean>(false);
//   const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
//   const [dates1, setDates1] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));


//   const onSubmit = async (values: any) => {
//     try {
//       const { fromDate, toDate } = values;
//       const FromDate = `${new Date(fromDate).getDate().toString().padStart(2, '0')}/${(new Date(fromDate)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(fromDate).getFullYear()}`;
//       const ToDate = `${new Date(toDate).getDate().toString().padStart(2, '0')}/${(new Date(toDate)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(toDate).getFullYear()}`;
//       if (investorId) {
//         setLoading(true)
//         const res = await dispatch(
//           getInvestorReports({
//             reportName: 'TransactionStatement',
//             // clientId: [replaceLetterOWithW(investorId) || ''],
//             clientId: [investorId || ''],
//             fromDate: FromDate,
//             toDate: ToDate,
//           })
//         );
//         setLoading(false)
//         downloadMultipleFiles(res);
//         enqueueSnackbar('File(s) downloaded successfully.', {
//           variant: 'success',
//           autoHideDuration: 3000,
//         });
//       }
//       setDates(dayjs(currentDate).format("YYYY-MM-DD"));
//       setDates1(dayjs(currentDate).format("YYYY-MM-DD"));
//     } catch (e) {
//       console.error((e as Error).message);
//     }
//   };

//   return (
//     <ReportsRightLayout>
//       <Typography
//         variant='h2'
//         sx={{
//           color: 'text.primary',
//           lineHeight: '25px',
//           letterSpacing: '0.01px',
//           mb: '40px',
//         }}>
//         Transaction Statement
//       </Typography>
//       <Formik
//         validationSchema={validationSchemaTransactionStatement}
//         initialValues={{
//           fromDate: new Date(),
//           toDate: new Date(),
//         }}
//         onSubmit={onSubmit}>
//         {({ values, setFieldValue }) => (
//           <Form>

//             {/* <ReportSectionContainer>
//               <Typography
//                 sx={{
//                   fontSize: '14px',
//                   fontWeight: 400,
//                   lineHeight: '22px',
//                   letterSpacing: '0.01em',
//                   pt: 1,
//                   pb: 1,
//                 }}>
//                 Choose duration of statement -
//               </Typography>
//               <Stack
//               >
//                 <LocalizationProvider dateAdapter={AdapterDayjs}
//                 >

//                   <DatePicker
//                     sx={{
//                       marginBottom: "30px"
//                     }}
//                     label="From Date"
//                     value={dayjs(dates)}
//                     maxDate={dayjs(currentDate)}

//                     onChange={(date: any) => {
//                       setDates(date.format("YYYY-MM-DD"))
//                       setFieldValue('fromDate', date)
//                     }
//                     }
//                   />

//                 </LocalizationProvider>

//                 <LocalizationProvider dateAdapter={AdapterDayjs}>

//                   <DatePicker
//                     label="TO Date"
//                     value={dayjs(dates1)}
//                     maxDate={dayjs(currentDate)}

//                     onChange={(date: any) => {
//                       setDates1(date.format("YYYY-MM-DD"))
//                       setFieldValue('toDate', date)
//                     }
//                     }
//                   />

//                 </LocalizationProvider>
//               </Stack>
//             </ReportSectionContainer>
//             <Stack justifyContent="center" alignItems="center" sx={{ m: 2 }}>
//               <MFSubmitButton
//                 label="Download"
//                 loadingEnable={loading}
//               // disabled={selectedFamilyMembers[0] === 'overall-family'}
//               />
//             </Stack> */}


//             <Grid container rowSpacing={4} >
//               <Grid item container columnSpacing={3}>
//                 <Grid item xs={12} lg={6}>
//                   <TextDatePicker
//                     inputLabelStyles={{
//                       transform: 'unset',
//                       fontSize: 14,
//                       fontWeight: 500,
//                       color: `${theme.palette.common.black}B3`
//                     }}
//                     name={'#'}
//                     placeholder='From Date'
//                     label="From Date"
//                     value={dayjs(dates).format('DD/MM/YYYY')}
//                     maxDate={new Date()}
//                     onSelect={(date: any) =>
//                       setDates(date.format("YYYY-MM-DD"))
//                     }
//                   />
//                 </Grid>
//                 <Grid item xs={12} lg={6}>
//                   <TextDatePicker
//                     inputLabelStyles={{
//                       transform: 'unset',
//                       fontSize: 14,
//                       fontWeight: 500,
//                       color: `${theme.palette.common.black}B3`
//                     }}
//                     name={'#'}
//                     placeholder='To Date'
//                     label="To Date"
//                     value={dayjs(dates1).format('DD/MM/YYYY')}
//                     maxDate={new Date()}
//                     onSelect={(date: any) =>
//                       setDates(date.format("YYYY-MM-DD"))
//                     }
//                   />
//                 </Grid>
//               </Grid>
//               <Grid item container columnSpacing={3}>
//                 <Grid item xs={12} lg={6}>

//                 </Grid>
//                 <Grid item xs={12} lg={6}>
//                   <MFSubmitButton
//                     label="Download"
//                     loadingEnable={loading}
//                   />
//                 </Grid>
//               </Grid>

//             </Grid>

//           </Form>
//         )}
//       </Formik>
//     </ReportsRightLayout>
//   );
// };

interface Values{
  selectedFromDate: string;
  selectedToDate: string;
  downloadOption: string;
  shareVia: string;
}



const TransactionStatement = ({
  location,
  handleSideSectionDisabled
}: {
  location: Location<{ investorId: string; investorName: string }>;
  handleSideSectionDisabled: (value: boolean) => void
}): JSX.Element => {
  const dispatch = useDispatch()

  const [isDownloading, setDownloading] = useState<boolean>(false)

  const { iwappRmId = "", investorClientId = "" } = useSelector((state: RootStateType) => state.id);
  const { investorName = "" } = useSelector((state: RootStateType) => state.id);
  const { panNo = "" } = useSelector((state: RootStateType) => state.id); 
  const { isNavbarInfoLoading, businessDate } = useSelector((state: RootStateType) => state.navbarInfo);
  const [isSuccessDialogOpen, setIsSuccessDialogOpen] = useState<boolean>(false)
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>("")
  const formikRef = useRef<FormikProps<Values>>(null)

  const todayDate = new Date();
  const formattedBusinessDate = businessDate?.length ? dayjs(businessDate, "DD/MM/YYYY").format("YYYY-MM-DD") : dayjs(todayDate).format("YYYY-MM-DD");

  const initialValues = {
    selectedFromDate: formattedBusinessDate,
    selectedToDate: formattedBusinessDate,
    downloadOption: '',
    shareVia: '',
  }

  const validationSchema = yup.object().shape({
    selectedFromDate: yup
      .date()
      .required('From Date is required')
      .typeError('From Date is required')
      .min(new Date("1950-01-01"), "From Date should not be less than 01/01/1950")
      .max(formattedBusinessDate, "From Date should not be greater than system's date")
      .test('fromDateTest', 'From Date cannot be greater than To Date', function (value) {
        const { selectedToDate } = this.parent;
        return !selectedToDate || !value || value <= selectedToDate;
      }),
    selectedToDate: yup
      .date()
      .required('To Date is required')
      .typeError('To Date is required')
      .min(new Date("1950-01-01"), "To Date should not be less than 01/01/1950")
      .max(formattedBusinessDate, "To Date should not be greater than system's date")
      .test('toDateTest', 'To Date cannot be less than From Date', function (value) {
        const { selectedFromDate } = this.parent;
        return !selectedFromDate || !value || value >= selectedFromDate;
      }),
    downloadOption: yup.string().required('Please select download option'),
    shareVia: yup.string().required('Please select share or download')
  })
  const handleSubmit = async ({
    selectedFromDate,
    selectedToDate,
    downloadOption,
    shareVia
  }: {
    selectedFromDate: string;
    selectedToDate: string;
    downloadOption: string;
    shareVia: string;
  }) => {
    try {
      setDownloading(true)
      handleSideSectionDisabled(true)
      const payload = {
        investorName:`${investorName}`,
        panNo:`${panNo}`,
        clientCode: `${investorClientId}`,
        rmId: `${iwappRmId}`,
        start: dayjs(selectedFromDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        end: dayjs(selectedToDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        isPDF: (downloadOption ?? "").toLowerCase() === 'pdf' ? true : false,
        shareVia: (shareVia ?? "").toLowerCase() === 'email' ? 'email' : 'download',
      }

      const response = await (dispatch(getCustomerTransactionHistoryReport(payload)) as unknown as Promise<any>)

      if (shareVia.toLowerCase() === 'download') {
        if (response.type) {
          setIsSuccessDialogOpen(true)

          reportDownload(response as unknown as Blob, `TransactionStatement.${response.type === CONTENT_TYPE.PDF ? 'pdf' : 'xlsx'}`);

        } else {
          setIsErrorDialogOpen(true)
          setErrorMessage('File download failed. Please try again.')
        }
      } else if (shareVia.toLowerCase() === 'email') {
        setIsSuccessDialogOpen(true)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setDownloading(false)
      handleSideSectionDisabled(false)
    }

  }

  return (
    <ReportsRightLayout>
      <Typography
        variant='h2'
        sx={{
          color: 'text.primary',
          lineHeight: '25px',
          letterSpacing: '0.01px',
          mb: { xs: '20px', sm: '40px' },
        }}>
        Transaction Statement
      </Typography>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        innerRef={formikRef}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Grid container rowSpacing={4} >
              <Grid item container columnSpacing={3}>
                <Grid item xs={12} lg={6}>
                  {isNavbarInfoLoading && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {!isNavbarInfoLoading && <DayJsDatePicker
                    id=""
                    name='selectedFromDate'
                    label="From Date"
                    maxDate={new Date(formattedBusinessDate)}
                    disabled={isDownloading}
                    currentDate={formattedBusinessDate}
                  />}
                </Grid>
                <Grid item xs={12} lg={6}>
                  {isNavbarInfoLoading && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {!isNavbarInfoLoading && <DayJsDatePicker
                    id=""
                    name='selectedToDate'
                    label="To Date"
                    maxDate={new Date(formattedBusinessDate)}
                    minDate={new Date(values.selectedFromDate)}
                    disabled={isDownloading}
                    currentDate={formattedBusinessDate}
                  />}
                </Grid>
                <Grid item xs={12} lg={6}>
                  {(isNavbarInfoLoading) && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {(!isNavbarInfoLoading) && <MFSelectField
                    name={'downloadOption'}
                    label="Select Download Option"
                    items={downloadOptions}
                    value={values.downloadOption}
                    onChange={(e) => {
                      setFieldValue('downloadOption', e.target.value);
                    }}
                    disabled={isDownloading}
                  />}
                </Grid>
                <Grid item xs={12} lg={6}>
                  {(isNavbarInfoLoading) && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {(!isNavbarInfoLoading) && <MFSelectField
                    name={'shareVia'}
                    label="Select Share or Download"
                    items={shareViaOptions}
                    value={values.shareVia}
                    onChange={(e) => {
                      setFieldValue('shareVia', e.target.value);
                    }}
                    disabled={isDownloading}
                  />}
                </Grid>
              </Grid>
              <Grid item container columnSpacing={3} justifyContent="flex-end">
                <Grid item xs={12} lg={6}>
                  {isNavbarInfoLoading && <Skeleton
                    animation={'wave'}
                    height={90}

                  />}
                  {!isNavbarInfoLoading && <MFSubmitButton
                    label="Proceed"
                    loadingEnable={isDownloading}
                  />}
                </Grid>
              </Grid>

            </Grid>

          </Form>
        )}
      </Formik>
      <Dialog
        aria-labelledby="success-dialog"
        open={isSuccessDialogOpen}
        PaperProps={{
          sx: (theme: Theme) => ({
            maxWidth: '550px',
            width: "100%",
            borderRadius: "12px",
            padding: "24px",
            backgroundColor: theme.palette.common.white
          }),
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: "12px",
            padding: "15px",
            overflow: "hidden"
          }}
        >
          <SuccessIcon />
          <Typography
            variant="h2"
            sx={(theme: Theme) => ({
              lineHeight: "25px",
              letterSpacing: "0.01px",
              color: theme.palette.text.primary
            })}
          >
            Success!
          </Typography>
          <Typography
            variant="subtitle_400"
            sx={(theme: Theme) => ({
              lineHeight: "22px",
              letterSpacing: "0.02px",
              color: theme.palette.text.secondary,
              textAlign: "center",
              paddingLeft: "10px",
              paddingRight: "10px"
            })}
          >
            {formikRef?.current?.values?.shareVia?.toLowerCase() === 'email' ? 'The statement has been  shared successfully.' : 'The statement has been downloaded successfully.'}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "0px",
            marginTop: "40px",
          }}
        >
          <Button
            fullWidth
            variant="contained"
            onClick={() => setIsSuccessDialogOpen(false)}
            sx={(theme: Theme) => ({
              ...theme.typography.body_500,
              fontWeight: 600,
              lineHeight: "20px",
              color: theme.palette.common.white,
              borderRadius: "4px",
              padding: "13px 20px",
              backgroundColor: theme.palette.primary[500]
            })}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        aria-labelledby="error-dialog"
        open={isErrorDialogOpen}
        PaperProps={{
          sx: (theme: Theme) => ({
            maxWidth: '550px',
            width: "100%",
            borderRadius: "12px",
            padding: "24px",
            backgroundColor: theme.palette.common.white
          }),
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: "12px",
            padding: "15px",
            overflow: "hidden"
          }}
        >
          <FailureIcon width="35" height="35" />
          <Typography
            variant="h2"
            sx={(theme: Theme) => ({
              lineHeight: "25px",
              letterSpacing: "0.01px",
              color: theme.palette.text.primary
            })}
          >
            Error!
          </Typography>
          <Typography
            variant="subtitle_400"
            sx={(theme: Theme) => ({
              lineHeight: "22px",
              letterSpacing: "0.02px",
              color: theme.palette.text.secondary,
              textAlign: "center",
              paddingLeft: "10px",
              paddingRight: "10px"
            })}
          >
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "0px",
            marginTop: "40px",
          }}
        >
          <Button
            fullWidth
            variant="contained"
            onClick={() => setIsErrorDialogOpen(false)}
            sx={(theme: Theme) => ({
              ...theme.typography.body_500,
              fontWeight: 600,
              lineHeight: "20px",
              color: theme.palette.common.white,
              borderRadius: "4px",
              padding: "13px 20px",
              backgroundColor: theme.palette.primary[500]
            })}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </ReportsRightLayout >
  )
}

export default TransactionStatement;
